/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sreality_Seller_Gsm_HintInputs */

const cs_sreality_seller_gsm_hint = /** @type {(inputs: Sreality_Seller_Gsm_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primární mobil makléře — na Sreality jde do contact_gsm. Stejné číslo jako veřejný telefon v profilu, pokud ho má.`)
};

const en_sreality_seller_gsm_hint = /** @type {(inputs: Sreality_Seller_Gsm_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Broker’s primary mobile — maps to Sreality contact_gsm. Same number as public profile phone when set.`)
};

/**
* | output |
* | --- |
* | "Broker’s primary mobile — maps to Sreality contact_gsm. Same number as public profile phone when set." |
*
* @param {Sreality_Seller_Gsm_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sreality_seller_gsm_hint = /** @type {((inputs?: Sreality_Seller_Gsm_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sreality_Seller_Gsm_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sreality_seller_gsm_hint(inputs)
	return cs_sreality_seller_gsm_hint(inputs)
});